import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class OtherMoudleService {

  public baseUrl: string;
  public newbaseUrl: string;
  selecteBranchMasterData: any = {};
  selecteServiceData: any = []
  constructor(public http: HttpClient, public authservice: AuthService, public snackBar: MatSnackBar) {
    this.baseUrl = this.authservice.baseUrl;
    this.newbaseUrl = this.authservice.newbaseUrl;
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })
  }
  GetAccountMaster() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetAccountMaster")
  }

  TRANSACTIONTYPEMASTER() {
    return this.http.get<any>(this.newbaseUrl + "GetNameByType/TRANSACTIONTYPEMASTER")
  }

  GetDailyExpensesByFinYearIdByBranchIdByCrAccId(id: any, id1: any, id2: any) {
    return this.http.get<any>(`${this.newbaseUrl}Utility/GetTotalDailyExpensesByFinYearIdByBranchIdByAccId/${id}/${id1}/${id2}`);
  }
  GetDailyExpensesByDateByFinYearByBranchId(year: any, id: any, id1: any) {
    return this.http.get<any>(`${this.newbaseUrl}Utility/GetDailyExpensesByDateByFinYearByBranchId/${year}/${id}/${id1}`);
  }

  InsertDailyExpenses(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Utility/InsertDailyExpenses", data)
  }

  getBranchMaster() {
    return this.http.get<any>(this.newbaseUrl + "branchMaster/getBranch/0")
  }

  GetLabSampleCollectionDetail(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Lab/GetLabSampleCollectionDetail", data)
  }

  labResultClinicalDept(type) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByType/" + type)
  }

  labResultApprovalStatus(type) {
    return this.http.get<any>(this.newbaseUrl + "Common/GetStatusByType/" + type)
  }

  labResultDeliveryStatus() {
    return this.http.get<any>(this.newbaseUrl + "Common/GetStatusByType/LABRESULTDELIVERYSTATUS")
  }

  GetLabSampleCollectionDetailByBillId(data: any) {
    return this.http.post<any>(this.newbaseUrl + "Lab/GetLabSampleCollectionDetailByBillId", data)
  }

  GetLabResult(TranId: any, ServiceId: any, BIllID: any, PType: any) {
    return this.http.get<any>(this.newbaseUrl + "Lab/GetLabResult/" + TranId + "/" + ServiceId + "/" + BIllID + "/" + PType)
  }

  InsertLabResultDetail(data) {
    return this.http.post<any>(this.newbaseUrl + "Lab/InsertLabResultDetail", data)
  }

  InsertLabSampleCollectionDetail(data) {
    return this.http.post<any>(this.newbaseUrl + "LAB/InsertLabSampleCollectionDetail", data)
  }

  // sample collection Api ...
  LabSampleCollection(data) {
    return this.http.post<any>(this.newbaseUrl + "Lab/GetLabSampleCollectionDetail", data)
  }

  InsertUpdateSampleStatus(data:any){
  return this.http.post<any>(this.newbaseUrl + "LAB/UpdateSampleStatus",data)
 }

//  sample Receving Api....
 getSampleReceving(data:any){
  return this.http.post<any>(this.newbaseUrl + "Lab/GetLabSampleReceivingDetail",data)
 }

 getSinNo(visitType:any,branchid:any){
  return this.http.get<any>(this.newbaseUrl + "GetNameByTypeByBranchId/" + visitType +'/'+ branchid)
 }

 getLabNo(visitType:any,branchid:any){
  return this.http.get<any>(this.newbaseUrl + "GetNameByTypeByBranchId/" + visitType +'/'+ branchid)
 }

}